import he from 'he';
import numeral from 'numeral';

var escapeUriPath = function (value, spaceReplacementChar) {
    var valueString = "".concat(value);
    valueString = valueString
        .trim()
        .replace(/[^\w\s]/gi, '')
        .replace(/ +/g, spaceReplacementChar ? spaceReplacementChar : '-');
    return valueString;
};
var changeAmazonImageUrlResolution = function (imageUrl, resolution) {
    var reg = /_SL\d+/;
    return imageUrl.includes('media-amazon.com') && imageUrl.includes('_SL')
        ? imageUrl.replace(reg, "_SL".concat(resolution))
        : imageUrl;
};
var isParentProduct = function (stacklineSku) {
    var regex = new RegExp('^(?:[0-9]_{1}:?){1}');
    return regex.test(stacklineSku);
};
var removeTrailingSlash = function (str) {
    return str.endsWith('/') ? str.slice(0, -1) : str;
};
var getRetailerFromId = function (retailerId) {
    var retailers = {
        1: 'Amazon',
        2: 'Walmart',
        3: 'Best Buy',
        4: 'Target',
        6: 'Home Depot',
        9: 'Costco',
        18: 'Chewy',
        48: 'Kroger',
        50: 'Sephora',
        92: 'Safeway',
        94: 'Albertsons',
        127: 'Fred Meyer',
        128: 'Ralphs',
        129: 'Kroger',
        116: 'PetSmart',
    };
    return retailers[retailerId] || "".concat(retailerId);
};
var hexadecimal = function (color) {
    return function (percentage) {
        var decimal = "0".concat(Math.round(255 * (percentage / 100)).toString(16)).slice(-2).toUpperCase();
        return color + decimal;
    };
};
var roundFloat = function (value, decimals) {
    if (decimals === void 0) { decimals = 4; }
    return value ? parseFloat(Number(value).toFixed(decimals)) : 0;
};
var formatMoney = function (num, currencySymbol, includeDecimal) {
    if (currencySymbol === void 0) { currencySymbol = '$'; }
    if (includeDecimal === void 0) { includeDecimal = true; }
    return numeral(roundFloat(num)).format("".concat(currencySymbol, "0,0").concat(includeDecimal ? ".00" : ""));
};
/**
 * Decode a string of HTML text
 *
 * This function takes a string of HTML and decodes any named
 * and numerical character references
 **/
var decodeHTMLCharacters = function (str) { return he.decode(str); };

export { changeAmazonImageUrlResolution, decodeHTMLCharacters, escapeUriPath, formatMoney, getRetailerFromId, hexadecimal, isParentProduct, removeTrailingSlash, roundFloat };
//# sourceMappingURL=stringUtils.js.map
